import { render, staticRenderFns } from "./BrandThemeSettings.vue?vue&type=template&id=c0721b24&scoped=true&"
import script from "./BrandThemeSettings.vue?vue&type=script&lang=js&"
export * from "./BrandThemeSettings.vue?vue&type=script&lang=js&"
import style0 from "./BrandThemeSettings.vue?vue&type=style&index=0&id=c0721b24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0721b24",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0721b24')) {
      api.createRecord('c0721b24', component.options)
    } else {
      api.reload('c0721b24', component.options)
    }
    module.hot.accept("./BrandThemeSettings.vue?vue&type=template&id=c0721b24&scoped=true&", function () {
      api.rerender('c0721b24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/BrandThemeSettings.vue"
export default component.exports